<template>
  <div id="becomeNote">
      <awesomeIcon icon="eye"/>
      <span>U bent een gebruiker aan het bekijken.</span>
      <button class="secondary" @click="unBecome">Verlaat gebruiker</button>
  </div>
</template>

<script>
export default {
  name: 'becomeNote',
  methods: {
    unBecome() {
      this.sdk.unbecome(() => {
        window.location.reload();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  #becomeNote {
    width: calc(100% - 220px);
    padding-left: 14px;
    box-sizing: border-box;
    height: 35px;
    color: #664d03;
    background-color: #fff3cd;
    position: fixed;
    top: 0;
    left: 220px;
    z-index: 100;
    span {
      padding-left: 5px;
      line-height: 35px;
    }
    svg {
      padding-bottom: 1px;
    }
    button {
      padding: 0 10px;
      height: 100%;
      float: right;
    }
  }
</style>
